<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 订单管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>对账单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.customerId" placeholder="请选择客户" filterable>
					<el-option key="" label="请选择客户" value=""></el-option>
					<el-option v-for="item in customersKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.status" placeholder="请选择状态">
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option v-for="item in statusKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="name" label="名称" width="360"></el-table-column>
                <el-table-column prop="start" label="时间区段" width="200" >
					<template slot-scope="scope"> 
						{{scope.row.start}} ~ {{scope.row.end}}
					</template>
				</el-table-column>
				<el-table-column prop="amount" label="金额"></el-table-column>
				<el-table-column prop="status" label="状态" :formatter="reconciliationFormat" width="80"></el-table-column>
				<el-table-column prop="realPayTime" label="支付时间" width="160"></el-table-column>
				<el-table-column prop="createTime" label="生成时间" width="160"></el-table-column>
                <el-table-column label="操作" width="230" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show']"
                        >详情</el-button>
						<el-button
                            type="text"
                            icon="el-icon-printer"
                            @click="handleExport(scope.$index, scope.row)"
							v-if = "controll['export'] && scope.row.status == 0 "
                        >导出</el-button>
						<el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleConfirm(scope.$index, scope.row)"
							v-if = "controll['confirm'] && scope.row.status == 0 "
                        >确认</el-button>
						<el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handlePaid(scope.$index, scope.row)"
							v-if = "controll['paid'] && scope.row.status == 1 "
                        >支付</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if = "controll['delete'] && scope.row.status == 0"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="70%">
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
				<el-row>
					<el-col :span="12">
						<el-form-item label="账期客户" prop="customerId">
							<el-select v-model="form.customerId" placeholder="请选择客户" filterable @change="onChangeCustomerId">
								<el-option key="" label="请选择客户" value=""></el-option>
								<el-option v-for="item in customersKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="账单名称" prop="name">
							<el-input v-model="form.name" placeholder="请输入账单名称" class="handle-input mr10"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="订单时间区段" prop="dateRange">
							<el-date-picker
								v-model="form.dateRange"
								type="daterange"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="预定支付时间" prop="payTime">
							<el-date-picker
								type="date"
								placeholder="预定支付时间"
								v-model="form.payTime"
								value-format="yyyy-MM-dd"
								style="width:150px"
							></el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
            </el-form>
			<el-table
				:data="orderList"
				border
				class="table"
				ref="multipleTable"
				header-cell-class-name="table-header"
				@selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
			>
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="orderNo" label="订单号"></el-table-column>
				<el-table-column prop="orderCompanyName" label="客户名称"></el-table-column>
				<el-table-column prop="total" label="数量" width="60"></el-table-column>
				<el-table-column prop="amount" label="金额" width="90"><template slot-scope="scope">￥{{scope.row.amount}}</template></el-table-column>
				<el-table-column prop="status" label="状态" :formatter="statusFormat" width="80"></el-table-column>
				<el-table-column prop="payTime" label="约定支付日期" width="160"></el-table-column>
				<el-table-column prop="createTime" label="下单时间" width="160"></el-table-column>
			</el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>申请</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="详情" :visible.sync="showVisible" width="70%">
			<el-tabs v-model="reconciliationActiveName" type="card">
				<el-tab-pane label="对账单" name="reconciliationTab">
					<el-descriptions class="margin-top" title="" :column="2" size="medium"  border>
						<el-descriptions-item>
							<template slot="label">
								对账单
							</template>
							{{show.name}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								对账周期
							</template>
							{{show.start}} ~ {{show.end}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								对账金额
							</template>
							{{show.amount}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								账单生成时间
							</template>
							{{show.createTime}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								状态
							</template>
							{{orderStatusFormat(null, null, show.status)}}
						</el-descriptions-item>
						<el-descriptions-item v-if = "show.confirmImg">
							<template slot="label">
								确认回执
							</template>
							<el-tooltip content="点击图片放大" placement="right" v-for = "confirmImgItem in show.confirmImg.split(',')" :key="index">
								<div style="float:left">
									<el-image
										class="table-td-thumb"
										:src="imgPrefix+confirmImgItem"
										:preview-src-list="[imgPrefix+confirmImgItem]"
									></el-image>
								</div>
							</el-tooltip>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								约定支付日期
							</template>
							{{show.payTime}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								实际支付时间
							</template>
							{{show.realPayTime}}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								余额支付
							</template>
							{{show.balancePayment==undefined?"0.00":show.balancePayment}}
						</el-descriptions-item>
						<el-descriptions-item v-if="show.payReceipt">
							<template slot="label">
								支付回单
							</template>
							<el-tooltip content="点击图片放大" placement="right" v-for = "payReceiptItem in show.payReceipt.split(',')" :key="index">
								<div style="float:left">
									<el-image
										class="table-td-thumb"
										:src="imgPrefix+payReceiptItem"
										:preview-src-list="[imgPrefix+payReceiptItem]"
									></el-image>
								</div>
							</el-tooltip>
						</el-descriptions-item>
					</el-descriptions>
				</el-tab-pane>
				<el-tab-pane label="订单记录" name="orderTab">
					<el-table
						:data="show.orders"
						border
						class="table"
						ref="multipleTable"
						header-cell-class-name="table-header"
						:cell-style="{padding:4+'px'}"
						stripe
					>
							<el-table-column prop="orderNo" label="订单号" width="130"></el-table-column>
							<el-table-column prop="orderCompanyName" label="客户名称"></el-table-column>
							<el-table-column prop="total" label="数量" width="60"></el-table-column>
							<el-table-column prop="amount" label="金额" width="90"><template slot-scope="scope">￥{{scope.row.amount}}</template></el-table-column>
							<el-table-column prop="arrivalStatus" label="出货状态" :formatter="arrivalStatusFormat" width="100"></el-table-column>
							<el-table-column prop="invoiceStatus" label="是否开票" width="90">
								<template slot-scope="scope" v-if="scope.row.status<6">
									<el-tag :type= "scope.row.taxIncluded?(scope.row.invoiceStatus?'success':'warning'):'info'" >{{scope.row.taxIncluded?(scope.row.invoiceStatus?'已开票':'未开票'):'无票'}} </el-tag>
								</template>
							</el-table-column>
							<el-table-column prop="status" label="状态" :formatter="statusFormat" width="80"></el-table-column>
							<el-table-column prop="createTime" label="下单时间" width="160"></el-table-column>
					</el-table>
				</el-tab-pane>
			</el-tabs>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showVisible = false">取 消</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="确认信息" :visible.sync="confirmVisible" width="35%">
			<el-form ref="confirm" :model="confirm" label-width="100px">
				<el-form-item label="对账单: " >
					{{confirm.name}}
				</el-form-item>
				<el-form-item label="对账周期: " >
					{{confirm.start}} ~ {{confirm.end}}
				</el-form-item>
				<el-form-item label="对账金额: " >
					￥{{confirm.amount}}
				</el-form-item>
				<el-form-item label="回传确认" prop="confirmImg">
					<el-upload
						class="upload-demo"
						multiple
						:before-upload="beforeUpload"
						:action= "confirmUploadUrl"
						:on-success="confirmUploadSuccess"
						:on-remove="handleConfirmRemove"
						:file-list="confirmFileList"
						accept=".png,.jpg"
						list-type="picture">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过1M</div>
					</el-upload>
				</el-form-item>
			</el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitConfirm" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="支付信息" :visible.sync="paidVisible" width="35%">
			<el-form ref="paid" :model="paid" label-width="100px">
				<el-form-item label="账单: " >
					{{paid.name}}
				</el-form-item>
				<el-form-item label="订单周期: " >
					{{paid.start}} ~ {{paid.end}}
				</el-form-item>
				<el-form-item label="订单金额: " >
					￥{{paid.amount}}
				</el-form-item>
				<el-form-item label="账户余额: " >
					￥{{accountBalance}}
				</el-form-item>
				<el-form-item label="挂账余额支付: " prop="balancePayment" v-if="accountBalance > 0">
					<el-input v-model="paid.balancePayment"></el-input>
				</el-form-item>
				<el-form-item label="支付回单" prop="payReceipt">
					<el-upload
						class="upload-demo"
						multiple
						:before-upload="beforeUpload"
						:action= "paidUploadUrl"
						:on-success="paidUploadSuccess"
						:on-remove="handlePaidRemove"
						:file-list="paidFileList"
						accept=".png,.jpg"
						list-type="picture">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过1M</div>
					</el-upload>
				</el-form-item>
			</el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="paidVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitPaid" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchOrderReconciliationData, saveOrderReconciliation, deleteOrderReconciliation, getOrderReconciliation, getPeriodCustomerKV, getPeriodNoPayShipmentOrders, buildReconciliationById, removeImg, reconciliationConfirm, reconciliationPaid, getCustomer} from '../../../api/index';
export default {
    name: 'order-reconciliation',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
			orderList: [],
            multipleSelection: [],
            editVisible: false,
			showVisible: false,
			confirmVisible : false,
			paidVisible: false,
            pageTotal: 0,
            form: {},
			show:{},
			update:{},
            idx: -1,
            id: -1,
			title:"",
			statusKV:[{"key":0,"value":"已生成"},{"key":1,"value":"已确认"},{"key":2,"value":"已付款"}],
			customersKV:[],
			salesDetailItems:[],
			rules: {
				customerId: [{ required: true, message: '请选择客户', trigger: 'blur' }],
				name: [{ required: true, message: '请输入账单名称', trigger: 'blur' }],
				payTime: [{ required: true, message: '请选择预定支付时间', trigger: 'blur' }]
			},
			confirmUploadUrl : "/image/upload/21",
			paidUploadUrl : "/image/upload/16",
			imgPrefix:"/image",
			confirmFileList:[],
			paidFileList:[],
			confirm:{},
			paid:{},
			accountBalance:0,
			reconciliationActiveName:"reconciliationTab",
			controll:{},
        };
    },
    created() {
		this.controll = getControll("order-reconciliation");
		let ckey = localStorage.getItem('ms_ckey');
		this.confirmUploadUrl = "/image/upload/" + ckey + "/21";
		this.paidUploadUrl = "/image/upload/" + ckey + "/16";
		this.getCustomers();
        this.getData();
    },
    methods: {
		reconciliationFormat(row, column, cellValue) {
			for (var i = 0; i < this.statusKV.length; i++) {
				if (this.statusKV[i].key === cellValue){
					return this.statusKV[i].value;
				}
			}
			return cellValue;
		},
		//订单状态格式化
		statusFormat(row, column, cellValue) {
			let statusConfig = {"0":"待审核","1":"待支付","2":"待发货","3":"发货中","4":"已发货","5":"已完结","6":"已撤销"};
			return statusConfig[cellValue];
		},
		//订单状态格式化
		orderStatusFormat(row, column, cellValue) {
			let statusConfig = {"0":"已生成","1":"已确认","2":"已支付"};
			return statusConfig[cellValue];
		},
		//发货状态格式化
		arrivalStatusFormat(row, column, cellValue) {
			let arrivalStatusConfig = {"0":"未发货", "1":"部分发货", "2":"全部发货", "3":"撤销"};
			return arrivalStatusConfig[cellValue];
		},
		//获取客户
		getCustomers() {
			getPeriodCustomerKV().then(res => {
				if (res.code == 0) {
					this.customersKV = res.data;
				} else {
					this.$message.error(`获取渠道信息失败！` + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchOrderReconciliationData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error(res.message);
				}
            });
        },
		getCurrentMonth() {
			let date = new Date();
			let month = date.getMonth() + 1;
			return date.getFullYear() + '-' + (month > 9?month:'0'+month);
		},
		onChangeCustomerId(value) {	
			this.orderList = [];
			if (this.form.customerId == undefined || this.form.customerId == "") {
				return;
			}
			this.$set(this.form, 'name', this.getCustomerName(value) + '(' + this.getCurrentMonth() + ")");
			getPeriodNoPayShipmentOrders(value).then(res => {
				if (res.code == 0 ) {
					this.orderList = res.data;
				} else {
					this.$message.error("获取订单数据失败！" + res.message);
				}
			});
		},
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteOrderReconciliation([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.orderList = [];
			this.multipleSelection = [],
			this.title = "申请对账单";
			this.editVisible = true;
		},
		getAmount(id) {
			let index = this.orderList.findIndex(item => {
				if (item.id === id) {
					return true;
				}
			});
			return this.orderList[index].amount;
		},
		getCustomerName(key) {
			let index = this.customersKV.findIndex(item => {
				if (item.key === key) {
					return true;
				}
			});
			return this.customersKV[index].value;
		},
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					const length = this.multipleSelection.length;
					if (length == 0) {
						this.$message.error(`请选择要对账的订单！`);
						return;
					}
					let ids = [];
					let total = 0;
					for (let i = 0; i < length; i++) {
						ids.push(this.multipleSelection[i].id);
						total = total + this.getAmount(this.multipleSelection[i].id);
					}
					this.form.orderIds = ids;
					this.$confirm('对账订单' + length + '个, 金额：' + total + ',  确认无误？', '提示', {
						type: 'warning'
					})
						.then(() => {
							if (this.form["dateRange"]) {
								this.$set(this.form, "start", this.form["dateRange"][0]);
								this.$set(this.form, "end", this.form["dateRange"][1]);
							}
							saveOrderReconciliation(this.form).then(res => {
								if (res.code == 0) {
									this.$message.success('对账单生成成功！');
									this.editVisible = false;
									this.dealVisible = false;
									this.getData();
								} else {
									this.$message.error(`对账单生成失败！` + res.message);
								}
							})
						})
						.catch(() => {});
					} else {
						this.$message.error('数据信息不完整！');
					}
			});
        },
		//确认
		handleConfirm(index, row) {
			this.confirmFileList = [];
			getOrderReconciliation(row.id).then(res => {
				if (res.code == 0) {
					this.confirm = res.data;
					if (this.confirm.confirmImg == undefined) {
						this.$set(this.confirm, "confirmImg", "");
					}
					this.confirmVisible = true;
				} else {
					this.$message.error(`获取对账单失败！` + res.message);
				}
			});
		},
		//确认图片上传
		confirmUploadSuccess(response, file, fileList) {
			this.confirm.confirmImg = this.confirm.confirmImg + (this.confirm.confirmImg==""?"":",") + response.data;
		},
		//删除确认图片
		handleConfirmRemove(file, fileList) {
			let fileName = file.response.data;
			removeImg([fileName]).then(res => {
				if (res.code == 0 ) {
					let files = this.confirm.confirmImg.split(",");
					let index = files.findIndex(item => {
						if (item === fileName) {
							return true;
						}
					});
					files.splice(index,1);
					this.confirm.confirmImg = files.join(",");
					this.$message.success("删除图片成功");
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		submitConfirm(){
			reconciliationConfirm(this.confirm).then(res => {
				if (res.code == 0) {
					this.confirmVisible = false;
					this.$message.success("对账单确认成功");
					this.getData();
				} else {
					this.$message.error(`对账单确认失败！` + res.message);
				}
			})
		},
		//支付
		handlePaid(index, row) {
			this.paid = row;
			this.paidVisible = true;
			this.paidFileList = [];
			this.$set(this.paid, 'payReceipt', "");
			this.$set(this.paid, 'balancePayment', 0);
			getCustomer(row.customerId).then(res => {
				if (res.code == 0) {
					this.accountBalance = res.data.base.accountBalance;
				} else {
					this.$message.error(`获取渠道挂账信息失败！` + res.message);
				}
			});
		},
		//支付图片上传
		paidUploadSuccess(response, file, fileList) {
			this.paid.payReceipt = this.paid.payReceipt + (this.paid.payReceipt==""?"":",") + response.data;
		},
		//删除支付图片
		handlePaidRemove(file, fileList) {
			let fileName = file.response.data;
			removeImg([fileName]).then(res => {
				if (res.code == 0 ) {
					let files = this.paid.payReceipt.split(",");
					let index = files.findIndex(item => {
						if (item === fileName) {
							return true;
						}
					});
					files.splice(index,1);
					this.paid.payReceipt = files.join(",");
					this.$message.success("删除图片成功");
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		//提交支付信息
		submitPaid(){
			reconciliationPaid(this.paid).then(res => {
				if (res.code == 0) {
					this.paidVisible = false;
					this.$message.success("对账单支付成功");
					this.getData();
				} else {
					this.$message.error(`对账单支付失败！` + res.message);
				}
			})
		},
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		handleExport(index, row){
			buildReconciliationById(row.id).then(res => {
				if (res.code == 0) {
					this.$router.push({path: "export-reconciliation", query:{key: res.data}});
				} else {
					this.$message.error(`对账单生成失败！` + res.message);
				}
			});
		},
		handleShow(index, row){
			getOrderReconciliation(row.id).then(res => {
				if (res.code == 0) {
					this.show = res.data;
					this.showVisible = true;
				} else {
					this.$message.error(`获取对账单失败！` + res.message);
				}
			});
		},
		beforeUpload(file){
			let limit = file.size / 1024 < 1024;
			if (!limit) {
			  this.$message.error('上传文件大小不能超过 1M');
			  return false;
			}
			return true;
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
